import React, { useEffect, useState } from 'react'
import { ApiGetChecklistTemplateQuestions, ApiUpdateChecklistTemplate, ApiUpdateChecklistTemplateQuestion } from '../../../../apiService/Core/Apicall.tsx';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, DialogActions, FormControl, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';

function ChangetemplateQuestionOrder() {
    const { templateId, templateName } = useParams();

    // const [questions, setQuestions] = useState([]);
    const [orderType, setOrderType] = useState<"question" | "category">("question");
    const [highlightedId, setHighlightedId] = useState<number | null>(null);
    const [questionOrders, setQuestionOrders] = useState<any[]>([]);
    const [categoryOrders, setCategoryOrders] = useState<any[]>([]);
    const navigate = useNavigate()

    useEffect(() => {
        fetchQuestions();
    }, []);

    const fetchQuestions = async () => {
        try {
            const data = `?offset=0&limit=100&checklistTemplateId=${templateId}`;
            const response = await ApiGetChecklistTemplateQuestions(data);

            const allQuestions =
                response?.data?.categories?.flatMap(
                    (category: any) => category.questions
                ) || [];

            allQuestions.sort(
                (a: any, b: any) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0)
            );

            setQuestionOrders(allQuestions);

            let categories = [...(response?.data?.categories || [])];

            if (response?.data?.categoryDisplayOrder) {
                const order = response.data.categoryDisplayOrder
                    .split(",")
                    .map((id: string) => Number(id.trim()));

                categories.sort((a: any, b: any) => {
                    const aIndex = order.indexOf(a.checklistCategoryId);
                    const bIndex = order.indexOf(b.checklistCategoryId);

                    // Categories not present in order string go to the end
                    return (
                        (aIndex === -1 ? Number.MAX_SAFE_INTEGER : aIndex) -
                        (bIndex === -1 ? Number.MAX_SAFE_INTEGER : bIndex)
                    );
                });
            }

            setCategoryOrders(categories);
        } catch (error: any) {
            toast.error(error.message);
        }
    };

    const handleOrderChange = (
        currentIndex: number,
        newOrder: number
    ) => {
        const list =
            orderType === "question"
                ? [...questionOrders]
                : [...categoryOrders];

        if (newOrder < 1 || newOrder > list.length) return;

        const [movedItem] = list.splice(currentIndex, 1);
        list.splice(newOrder - 1, 0, movedItem);

        if (orderType === "question") {
            setQuestionOrders(list);
            setHighlightedId(movedItem.checklistTemplateQuestionId);
        } else {
            setCategoryOrders(list);
            setHighlightedId(movedItem.checklistCategoryId);
        }

        setTimeout(() => setHighlightedId(null), 1000);
    };

    const handleSaveOrder = async () => {
        try {
            const data = {
                questions: questionOrders.map((q, index) => ({
                    checklistTemplateQuestionId:
                        q.checklistTemplateQuestionId,
                    displayOrder: index
                }))
            }
            const data2= {
                checklistTemplateId:templateId,
                categoryDisplayOrder: categoryOrders?.map((category) => category.checklistCategoryId).join(",")
            }
            // console.log("Data--->", data)
            const res = orderType === "question" ? await ApiUpdateChecklistTemplateQuestion(data) : await ApiUpdateChecklistTemplate(data2)
            if (res?.status || res?.success) {
                toast.success(res?.message)
                navigate(-1)
            }
        } catch (error: any) {
            toast.error(error?.message || "Something went worng")
        }
    }
    return (
        <Box className='p-3'>
            <Box className="d-flex extra gap-2 mb-3">
                <ToggleButtonGroup className='mb-5' sx={{ borderRadius: "10px" }} value={orderType} onChange={(e: any) => { setOrderType(e.target.value) }}>
                    <ToggleButton className='py-2 px-3' sx={{ textTransform: "none" }} value={'question'}>
                        Set Question Order
                    </ToggleButton>
                    <ToggleButton className='py-2 px-3' sx={{ textTransform: "none" }} value={'category'}>
                        Set Category Order
                    </ToggleButton>
                </ToggleButtonGroup>

            </Box>

            {orderType === "question" ?
                questionOrders?.map((question, index) => (
                    <Box
                        key={question.checklistTemplateQuestionId}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                            p: 2,
                            mb: 2,
                            border:
                                highlightedId === question.checklistTemplateQuestionId
                                    ? "2px solid #4CAF50"
                                    : "1px solid #ddd",
                            transition: "all .3s ease",
                            animation:
                                highlightedId === question.checklistTemplateQuestionId
                                    ? "blinkBorder 1s ease"
                                    : "none",
                            borderRadius: 2
                        }}
                    >
                        <Typography sx={{ width: 40 }}>
                            #{index + 1}
                        </Typography>

                        <Box sx={{ flex: 1 }}>
                            <Typography
                                dangerouslySetInnerHTML={{
                                    __html: question.question
                                }}
                            />
                        </Box>

                        <FormControl size="small" sx={{ width: 100 }}>
                            <TextField
                                size="small"
                                type="number"
                                label="Order"
                                value={index + 1}
                                inputProps={{
                                    min: 1,
                                    max: questionOrders.length
                                }}
                                onChange={(e) =>
                                    handleOrderChange(
                                        index,
                                        Number(e.target.value)
                                    )
                                }
                                sx={{ width: 100 }}
                            />
                        </FormControl>
                    </Box>
                ))
                :
                categoryOrders?.map((category, index) => (
                    <Box
                        key={category?.checklistCategoryId}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                            p: 2,
                            mb: 2,
                            border:
                                highlightedId === category?.checklistCategoryId
                                    ? "2px solid #4CAF50"
                                    : "1px solid #ddd",
                            transition: "all .3s ease",
                            animation:
                                highlightedId === category?.checklistCategoryId
                                    ? "blinkBorder 1s ease"
                                    : "none",
                            borderRadius: 2
                        }}
                    >
                        <Typography sx={{ width: 40 }}>
                            #{index + 1}
                        </Typography>

                        <Box sx={{ flex: 1 }}>
                            {/* <Typography
                                dangerouslySetInnerHTML={{
                                    __html: question.question
                                }}
                            /> */}
                            <Typography>{category?.categoryName}</Typography>
                        </Box>

                        <FormControl size="small" sx={{ width: 100 }}>
                            <TextField
                                size="small"
                                type="number"
                                label="Order"
                                value={index + 1}
                                inputProps={{
                                    min: 1,
                                    max: categoryOrders?.length
                                }}
                                onChange={(e) =>
                                    handleOrderChange(
                                        index,
                                        Number(e.target.value)
                                    )
                                }
                                sx={{ width: 100 }}
                            />
                        </FormControl>
                    </Box>
                ))
            }

            <Box className='d-flex align-items-center justify-content-end'>
                <Button
                    variant="contained"
                    className='bg-grey ms-auto text-light link-btn whitespace px-3 py-2'
                    onClick={() => { handleSaveOrder() }}
                >
                    Save
                </Button>
            </Box>
        </Box>
    )
}

export default ChangetemplateQuestionOrder
